import Spacer from "@components/atoms/Spacer";
import { SpaceType } from "@components/atoms/Spacer/types";
import TopTabs from "@components/molecules/TopTab";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { Diamond } from "@src/types/DiamondDetail";
import { MemoStatus } from "@src/types/HistoryRequest";
import { SubSection } from "@utils/customization";
import { VDBIcons } from "@utils/VDBIcons";
import { Fragment, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components/native";

type CustomTabsProps = {
  subSections: SubSection[];
  handleRequestChange: (option: string) => void;
  selectedOption: string;
  disabledMemo: boolean;
  itemDetail: Diamond;
  price_mode: number;
  disableSoldReturnRequest: MemoStatus;
  testIDPrefix?: string;
};

const CustomTabs = ({
  subSections,
  handleRequestChange,
  selectedOption,
  disabledMemo,
  itemDetail,
  price_mode,
  disableSoldReturnRequest,
  testIDPrefix = "bmh.tabs",
}: CustomTabsProps) => {
  const theme = useTheme();
  const typography = useTypographyStore();
  const { t } = useTranslation();
  const getSubSectionsByPriceMode = (data: any, priceMode: number) => {
    return data.filter((section: any) =>
      section?.price_modes?.includes(priceMode)
    );
  };
  const filtererdsubSections = getSubSectionsByPriceMode(
    subSections,
    price_mode
  );

  const renderTabs = useCallback(() => {
    return filtererdsubSections.map((section: any, index: number) => {
      const option = section?.name?.includes("_")
        ? section.name.split("_")[1]
        : section?.name;
      const isSelected = selectedOption === option;
      const isMemoDisabled = option === "memo" && disabledMemo;

      const iconName =
        option === MemoStatus.Return
          ? VDBIcons.REFRESH_CIRCLE
          : option === MemoStatus.Sold
          ? VDBIcons.BUY
          : option;

      const iconColor = isSelected
        ? theme["core-05"]
        : isMemoDisabled ||
          disableSoldReturnRequest === MemoStatus.Sold ||
          disableSoldReturnRequest === MemoStatus.Return
        ? theme["core-04"]
        : theme["core-06"];

      const textType = isSelected ? typography["Body-M"] : typography["Body-R"];

      const textColor = isSelected
        ? theme["core-05"]
        : isMemoDisabled ||
          disableSoldReturnRequest === MemoStatus.Sold ||
          disableSoldReturnRequest === MemoStatus.Return
        ? theme["core-04"]
        : theme["core-06"];

      return (
        <Fragment key={index}>
          <TopTabs
            testID={`${testIDPrefix}.tab.${option}`}
            onPress={() =>
              disableSoldReturnRequest === MemoStatus.Sold ||
              disableSoldReturnRequest === MemoStatus.Return
                ? null
                : handleRequestChange(option)
            }
            iconColor={iconColor}
            iconName={iconName}
            text={t(section?.label)}
            textTypes={textType}
            textColor={textColor}
            lineviewSelected={isSelected}
            toolTip={isMemoDisabled}
            itemType={itemDetail?.type}
          />
          <Spacer size={SpaceType.ExtraSmall} />
        </Fragment>
      );
    });
  }, [
    subSections,
    selectedOption,
    theme,
    typography,
    disabledMemo,
    itemDetail,
    handleRequestChange,
    t,
    testIDPrefix,
  ]);

  return <>{renderTabs()}</>;
};

export default CustomTabs;
